import { templateCriteriaModifications, } from './helpers/actions-helper'

export default {
  record: null,
  rawRecord: null,
  recordNotFound: false,
  ra: null,
  elf: null,
  isin: null,
  childrenMaxCount: 50,
  showUltimateChildrenMoreBtn: false,
  showDirectChildrenMoreBtn: false,
  modifications: null,
  leiIssuers: {},
  handledAssociatedEntity: null,
  handledSuccessorEntity: null,
  rawSuccessorEntities: null,
  timelineTable: {
    total: 0,
    currentPage: 1,
    lastPage: 1,
    perPage: 15,
    perColumn: 15,
  },
  directParentRelationship: null,
  ultimateParentRelationship: null,
  directParentReportingException: null,
  ultimateParentReportingException: null,
  directParent: null,
  ultimateParent: null,
  directChildren: [],
  ultimateChildren: [],
  directChildrenRelationships: null,
  ultimateChildrenRelationships: null,
  directChildrenCount: 0,
  ultimateChildrenCount: 0,
  showEmptyFields: false,
  showCDF: false,
  showRelationshipData: false,
  showFullData: false,
  relationship: {
    parent: null,
    child: null,
    info: null,
    exception: null,
  },
  relationshipParent: null,
  relationshipTarget: null,
  relationshipChild: null,
  showRelationshipRegistrationData: true,
  showRelationshipDetails: true,
  showRelationshipDates: true,
  showRelationshipException: true,
  showEntityDetails: true,
  showAddresses: true,
  showRegistrationDetails: true,
  showLOUDetails: true,
  showLevelTwoParents: true,
  showLevelTwoChildren: true,
  showChangeLog: true,
  showRRChanges: true,
  showREPEXChanges: true,
  showMetaData: true,
  showHistoricalData: true,
  showIssuerModal: false,
  showModificationsModal: false,
  showChangesModal: false,
  modificationType: null,
  recordModifications: {
    lei: {},
    rr: {},
    repex: {},
    changed: false,
  },
  xmlData: {
    lei: {
      record: {
        lei: null,
        xml: '',
      },
    },
    rr: {
      directParent: { 
        lei: null,
        xml: '',
      },
      ultimateParent: { 
        lei: null,
        xml: '',
      },
      fundManager: {
        lei: null,
        xml: '',
      },
      umbrellaFund: {
        lei: null,
        xml: '',
      },
      masterFund: {
        lei: null,
        xml: '',
      },
      headOffice: {
        lei: null,
        xml: '',
      },
    },
    repex: {
      directParentException: {
        lei: null,
        xml: '',
      },
      ultimateParentException: {
        lei: null,
        xml: '',
      },
    },
  },
  loading: false,
  criteriaModifications: templateCriteriaModifications(),
  showEventsChangeLog: true,
  headOffice: null,
  branches: [],
  fundManager: null,
  managedFunds: [],
  umbrellaFund: null,
  subFunds: [],
  masterFund: null,
  feederFunds: [],
  branchesCount: 0,
  managedFundsCount: 0,
  subFundsCount: 0,
  feederFundsCount: 0,
  showBranchesMoreBtn: false,
  showManagedFundsMoreBtn: false,
  showSubFundsMoreBtn: false,
  showFeederFundsMoreBtn: false,
  showLevelTwoFunds: true,
  showLevelTwoBranches: true,
  headOfficeRelationship: null,
  branchesRelationships: null,
  fundManagerRelationship: null,
  managedFundsRelationships: null,
  umbrellaFundRelationship: null,
  subFundsRelationships: null,
  masterFundRelationship: null,
  feederFundsRelationships: null,
  addressData: {
    addressData: null,
    type: null,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/state.js